import { RightOutlined, SearchOutlined } from "@ant-design/icons";
import { Button, Col, DatePicker, Empty, Form, Input, PageHeader, Row, Select, Space } from 'antd'
import React, { useEffect, useState } from 'react'
import moment from 'moment';

import accountService from "../../api/account.service";
import memberService from "../../api/member.service";
import ProgrammeService from '../../api/programme.service'
import AdminBreadCrumb from '../../components/layout/AdminBreadCrumb'
import PaymentPaidList from '../../components/payment/PaymentPaidList'
import VoucherListView from "../../components/voucher/VoucherListView";
import { DATE_FORMAT_DMY_SLASH, SERVER_ERROR, SUCCESS_STATUS, TRY_AGAIN_ERROR } from '../../utility/Constants'
import commonUtility from "../../utility/Utils";
import OtherItemsListView from "../../components/otheritem/OtherItemsListView";
import TimeScheduleReport from "./TimeScheduleReport";
import commonService from "../../api/common.service";
import AllReceiptView from "../../components/report/AllReceiptView";
import { MEMBER_OUTSTANDING_PRINT_URL, MEMBER_OUTSTANDING_DUE_PRINT_URL, MEMBER_OUTSTANDING_PRINT_URL_EXCEL, MEMBER_OUTSTANDING_DUE_MONTHLY_PRINT_URL, MEMBER_OUTSTANDING_MONTHLY_PRINT_URL_EXCEL } from "../../utility/URL";
const { Option } = Select;


const defaultFormValues = {
    receipt_start_date: commonUtility.firstDateOfMonth(),
    receipt_end_date: commonUtility.lastDateOfMonth(),
    member_id: "",
    from_month_id: 1,
    to_month_id: 12,
    group_id: '0',
};



const OutstandingReport = () => {
    const [form] = Form.useForm();



    const [monthList, setMonthList] = useState([]);
    const [yearList, setYearList] = useState([]);
    const [selectedFromDate, setSelectedFromDate] = useState("");
    const [selectedEndDate, setSelectedEndDate] = useState("");
    const [isDataUpdated, setIsDataUpdated] = useState(false);
    const [programmeList, setProgrammeList] = useState([]);
    const [memberList, setMemberList] = useState([]);
    const [programmeID, setProgrammeID] = useState(0);
    const [reportList, setReportList] = useState([]);
    const [programmeGroupList, setProgrammeGroupList] = useState([]);
    const [selectedProgramme, setSelectedProgramme] = useState(null);




    // const onSelectMember = (value,obj) => {

    //     //const data = { formdata: { member_id: value } };
    //     form.setFieldsValue({
    //         member_id: value,
    //         enrollment_id:obj.enrollment_id
    //     });
    // };


    // const onFromDateChange = (date, dateString) => {
    //     // console.log(date, dateString);
    //     setSelectedFromDate(dateString)
    //     form.setFieldsValue({
    //         receipt_start_date: dateString
    //     });
    // };

    // const onEndDateChange = (date, dateString) => {
    //     // console.log(date, dateString);
    //     setSelectedEndDate(dateString)
    //     form.setFieldsValue({
    //         receipt_end_date: dateString
    //     });

    // };

    const onSelectProgrammeGroup = (value, obj) => {
        form.setFieldsValue({
            group_id: value
        });
    }


    const onReportSearch = async (values) => {

        setReportList([])

        // console.log('values',values);

        const formdValues = {
            programme_id: values.programme_id == undefined ? '' : values.programme_id,
            from_month: values.from_month_id,
            to_month: values.to_month_id,
            group_id: values.group_id == undefined || !(selectedProgramme == 3 || selectedProgramme == 4) ? '0' : values.group_id,
            year: values.year

        }

        const data = { formdata: formdValues };

        memberService.programWiseMembersOutStanding(data).then((res) => {
            if (res.data.response_status == SUCCESS_STATUS) {

                // let url = `${MEMBER_OUTSTANDING_PRINT_URL}${formdValues.programme_id}/${formdValues.from_month}/${formdValues.to_month}/${formdValues.year}/${commonUtility.getLoggedInUserInfo()?.companyID > 0 ? commonUtility.getLoggedInUserInfo()?.companyID : 0 }`
                let url = `${MEMBER_OUTSTANDING_DUE_MONTHLY_PRINT_URL}${formdValues.year}/${formdValues.programme_id}/${formdValues.group_id}/${formdValues.from_month}/${formdValues.to_month}/`
                commonUtility.openInNewTab(url);
            }
            else {
                commonUtility.openNotificationWithType("error", "bottomRight", "Error", SERVER_ERROR);
            }

        });
    };



    const onProgrammeChange = (id, object) => {
        setSelectedProgramme(id);
        //getMemberList(object?.short_code)
    }



    useEffect(() => {
        ProgrammeService.programmeListForScheduleReport().then((res) => {
            if (res.data.response_status === SUCCESS_STATUS) {
                setProgrammeList(res.data.response_data);
            }
        });

    }, []);

    useEffect(() => {
        ProgrammeService.monthList().then((res) => {
            if (res.data.response_status === SUCCESS_STATUS) {
                setMonthList(res.data.response_data);
            }

        });
    }, []);
    // useEffect(() => {
    //     ProgrammeService.yearList().then((res) => {
    //         if (res.data.response_status === SUCCESS_STATUS) {
    //             setYearList(res.data.response_data);
    //         }

    //     });
    // }, []);

    useEffect(() => {
        commonService.getYearList().then((res) => {
            // console.log(res);
            if (res.data.status === SUCCESS_STATUS) {
                setYearList(res.data.result);
            }

        });
    }, []);

    useEffect(() => {
        ProgrammeService.programmeGroupList().then((res) => {
            if (res.data.response_status === SUCCESS_STATUS) {
                setProgrammeGroupList(res.data.response_data);
            }
        });
    }, []);



    /*
    useEffect(() => {
        memberService.allMember().then((res) => {
            if (res.data.response_status === SUCCESS_STATUS) {
                setMemberList(res.data.response_data);
            }
        });
    }, []);
    */




    // const getMemberList = (short_code) => {

    //     form.setFieldsValue({
    //         member_search: '',
    //         member_id: ''
    //     });

    //     const data = {
    //         formdata: {
    //             programme_id: short_code
    //         }
    //     };

    //     ProgrammeService.memberListPromoted(data).then((res) => {
    //         if (res.data.response_status === SUCCESS_STATUS) {
    //             setMemberList(res.data.response_data);
    //         }
    //     });
    // }





    // useEffect(() => {
    //     const formdValues = {
    //         member_id: form.getFieldValue('member_id') == undefined ? '' : form.getFieldValue('member_id'),
    //         receipt_start_date: commonUtility.firstDateOfMonth(),
    //         receipt_end_date: commonUtility.lastDateOfMonth(),
    //     }
    // }, [])

    const handlePrint = (values) => {
        const formdValues = {
            programme_id: values.programme_id == undefined ? '' : values.programme_id,
            from_month: values.from_month_id,
            to_month: values.to_month_id,
            group_id: values.group_id == undefined || !(selectedProgramme == 3 || selectedProgramme == 4) ? '0' : values.group_id,
            year: values.year

        }
        let url = `${MEMBER_OUTSTANDING_MONTHLY_PRINT_URL_EXCEL}${formdValues.year}/${formdValues.programme_id}/${formdValues.group_id}/${formdValues.from_month}/${formdValues.to_month}/`
        commonUtility.openInNewTab(url);
    };

    return (
        <div>


            <div className="inside-main-content">
                <AdminBreadCrumb />

                <div className="box-style">
                    <PageHeader
                        ghost={false}
                        onBack={() => window.history.back()}
                        title="Outstanding Report Month Wise"
                        subTitle=""

                    ></PageHeader>

                    <div className="">



                        <Row className="" style={{ background: "rgb(249, 249, 249)" }}>
                            <Col className="" xs={24} xl={24} style={{ margin: "0.5rem" }}>
                                <Form
                                    form={form}
                                    layout="vertical"
                                    onFinish={onReportSearch}
                                    autoComplete="off"
                                    initialValues={defaultFormValues}
                                >

                                    <Row gutter={10} >


                                        <Col xs={3} xl={3} >
                                            <Form.Item name="from_month_id" label="From Month" rules={[
                                                {
                                                    required: true,
                                                    message: "Select Month",
                                                },
                                            ]}>
                                                <Select 
                                                    className="text-left"
                                                    onChange={() => {
                                                        form.validateFields(['to_month_id']);
                                                    }}
                                                >
                                                    {monthList.length > 0 &&
                                                        monthList
                                                            .sort((a, b) => a.display_serial - b.display_serial)
                                                            .map(month => (
                                                                <Option
                                                                    key={month.display_serial}
                                                                    value={month.display_serial}
                                                                >
                                                                    {month.short_name}
                                                                </Option>
                                                            ))}
                                                </Select>
                                            </Form.Item>
                                        </Col>

                                        <Col xs={3} xl={3} >
                                            <Form.Item name="to_month_id" label="To Month" rules={[
                                                {
                                                    required: true,
                                                    message: "Select Month",
                                                },
                                                ({ getFieldValue }) => ({
                                                    validator(_, value) {
                                                        const fromMonth = getFieldValue('from_month_id');
                                                        if (!value || !fromMonth || value >= fromMonth) {
                                                            return Promise.resolve();
                                                        }
                                                        return Promise.reject(new Error('Should not be less than From Month'));
                                                    },
                                                }),
                                            ]}>
                                                <Select 
                                                    className="text-left"
                                                    onChange={() => {
                                                        form.validateFields(['to_month_id']);
                                                    }}
                                                >
                                                    {monthList
                                                        .sort((a, b) => a.display_serial - b.display_serial)
                                                        .map(month => (
                                                            <Option
                                                                key={month.display_serial}
                                                                value={month.display_serial}
                                                                disabled={
                                                                    form.getFieldValue('from_month_id') &&
                                                                    month.display_serial < form.getFieldValue('from_month_id')
                                                                }
                                                            >
                                                                {month.short_name}
                                                            </Option>
                                                        ))}
                                                </Select>
                                            </Form.Item>
                                        </Col>

                                        <Col xs={3} xl={3}>
                                            <Form.Item name="year" label="Year" rules={[
                                                {
                                                    required: true,
                                                    message: "Select Year",
                                                },
                                            ]} >
                                                <Select className="text-left"  >

                                                    {
                                                        yearList.length > 0 ?
                                                            yearList.map(year_data => (
                                                                <Option key={year_data.year_id} value={year_data.year_id}>{year_data.year}</Option>

                                                            ))
                                                            : ''
                                                    }
                                                </Select>
                                            </Form.Item>
                                        </Col>

                                        <Col xs={5} xl={5}>
                                            <Form.Item
                                                name="programme_id"
                                                label="Programme"
                                                rules={[
                                                    {
                                                        required: true,
                                                        message: 'Programme is required',
                                                    },
                                                ]}
                                            >
                                                <Select className="text-left"
                                                    onSelect={(value, event) =>
                                                        onProgrammeChange(value, event)
                                                    }
                                                >
                                                    <Option value="">Select</Option>
                                                    {programmeList.length > 0
                                                        ? programmeList.map((programme_list) => (
                                                            <Option
                                                                key={programme_list.programme_id}
                                                                value={programme_list.programme_id}
                                                                short_code={programme_list.short_code}
                                                            >
                                                                {programme_list.programme_name}
                                                            </Option>
                                                        ))
                                                        : ""}
                                                </Select>
                                            </Form.Item>
                                        </Col>

                                        <Col xs={24} xl={5}>
                                            <Form.Item
                                                name="group_id"
                                                label="Programme Group (Shift)"

                                            >
                                                <Select
                                                    className="text-left"
                                                    onSelect={(value, event) =>
                                                        onSelectProgrammeGroup(value, event)
                                                    }
                                                    disabled={!(selectedProgramme == 3 || selectedProgramme == 4)}
                                                >
                                                    <Option value="0">Select</Option>
                                                    {programmeGroupList.length > 0
                                                        ? programmeGroupList.map((programme_group_list) => (
                                                            <Option
                                                                key={programme_group_list.programme_group_id}
                                                                value={programme_group_list.programme_group_id}
                                                            >
                                                                {programme_group_list.programme_group}
                                                            </Option>
                                                        ))
                                                        : ""}
                                                </Select>
                                            </Form.Item>
                                        </Col>



                                        <Col xs={24} xl={1}>
                                            <Form.Item label=" ">
                                                <Button
                                                    htmlType="submit"
                                                    shape="round"

                                                    className="custom-button-green"
                                                >
                                                    <SearchOutlined /> View PDF
                                                </Button>
                                            </Form.Item>
                                        </Col>



                                        <Col xs={24} xl={1} style={{ marginLeft: '80px' }}>
                                            <Form.Item label=" ">
                                                <Button
                                                    htmlType="button"
                                                    shape="round"
                                                    onClick={async () => {
                                                        try {
                                                            const values = await form.validateFields(); // runs validation & formats
                                                            handlePrint(values);
                                                        } catch (errorInfo) {
                                                            console.log("Validation failed:", errorInfo);
                                                        }
                                                    }}
                                                    className="custom-button-green"
                                                >
                                                    Excel
                                                </Button>
                                            </Form.Item>
                                        </Col>


                                    </Row>
                                </Form>



                            </Col>
                        </Row>


                        {/* <VoucherListView voucherListValue={voucherList} voucherMasterDataValue={voucherMasterData} voucherDetailDataValue={voucherDetailData} isDataUpdatedValue={isDataUpdated}/> */}

                        {/* <OtherItemsListView /> */}



                        {/* <div className='tableView'>
                            <div className="form-content">
                                <AllReceiptView reportList={reportList} isDataUpdatedValue={isDataUpdated} />
                            </div>
                        </div> */}




                    </div>

                </div>
            </div>

        </div>


    )
}

export default OutstandingReport